import * as React from 'react';

import { Link } from 'react-router-dom';

import Base from './Base';

import formatDate from 'date-fns/format';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react';
import { useSelector } from 'react-redux';

const componentCss = css`


`;

export default React.forwardRef(({ selectedNav, index, auth }, ref) => {

	const clients = useSelector(state => state.CLIENT_LIST)?.items ?? [];

	return <div css={componentCss}>
		<Base ref={ref} index={index} selectedNav={selectedNav}>
			<div className="megamenu">
				<div className="megamenu-columns">
					<div className="primary-columns">
						<h2>Runs</h2>
						<div className="columns-2">
							<div className="primary-column">
								<h3>Manage</h3>
								{auth.user.role === 'admin' &&
								<Link to={`/run/assign/contractor/1/${formatDate(new Date(), 'yyyy-MM-dd')}/rg/all/all`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-truck-loading fa-fw" />
											</div>
										</div>
										<div>
											<h4>Assign Contractor</h4>
											<p className="link-subtext">Assign</p>
										</div>
									</div>
								</Link>
								}
								<Link to={`/run/assign/driver/1/${formatDate(new Date(), 'yyyy-MM-dd')}/rg/all/all`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-user fa-fw" />
											</div>
										</div>
										<div>
											<h4>Assign Driver</h4>
											<p className="link-subtext">Assign</p>
										</div>
									</div>
								</Link>
								<Link to={`/run/r/country/1/${formatDate(new Date(), 'yyyy-MM-dd')}`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-truck-bolt fa-fw" />
											</div>
										</div>
										<div>
											<h4>Run Summary</h4>
											<p className="link-subtext">View</p>
										</div>
									</div>
								</Link>
								<Link to={`/run/r/events/all`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-brands fa-elementor fa-fw" />
											</div>
										</div>
										<div>
											<h4>Run Events</h4>
											<p className="link-subtext">View</p>
										</div>
									</div>
								</Link>
							</div>
							<div className="primary-column">
								<h3>Manage</h3>
								<Link to={`/run/runs/all`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-truck-arrow-right fa-fw" />
											</div>
										</div>
										<div>
											<h4>Run List</h4>
											<p className="link-subtext">View and Manage runs</p>
										</div>
									</div>
								</Link>
								<Link to={`/run/drops/all`} >
									<div className="megamenu-link">
										<div className="logo-wrapper">
											<div className="megamenu-icon">
												<i className="fa-solid fa-droplet fa-fw" />
											</div>
										</div>
										<div>
											<h4>Drop List</h4>
											<p className="link-subtext">View and manage drops</p>
										</div>
									</div>
								</Link>
							</div>
						</div>
					</div>
					<div className="secondary-columns">
						<ul>

						</ul>
					</div>
				</div>
			</div>
		</Base>
	</div>

});
